<!-- @format -->

<template>
  <div class="ui">
    <div v-if="!getRiskAbilityResponse">
      <div class="ui segment">
        <div class="ui equal width grid">
          <div class="ui equal width row">
            <div class="ui column" style="text-align: center">
              <a href="#" @click.prevent="initialSelection(false)">
                <Section
                  :style="'[adding: ]; font-weight: bold;font-size: 1.3em;'"
                  >Score
                  <br />
                  <span style="font-size: small"
                    >time horizon, liquidity, capacity
                  </span></Section
                ></a
              >
            </div>
            <div class="ui column" style="text-align: center">
              <a href="#" @click.prevent="initialSelection(true)"
                ><Section :style="'font-weight: bold; font-size: 1.3em'">
                  Manual
                  <br />
                  <span style="font-size: small">subjective judgment </span>
                </Section></a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="">
        <div class="ui segment">
          <div class="ui equal width grid">
            <div class="ui equal width row">
              <div class="ui column" style="text-align: center">
                <a href="#" @click.prevent="overrideRiskProfile = false">
                  <Section
                    :style="
                      !overrideRiskProfile
                        ? 'background-color: rgba(80, 180, 80, 0.2); font-weight: bold; font-size: 1.3em;color: black;cursor: text'
                        : '[adding: ]; font-weight: bold;font-size: 1.3em;'
                    "
                    >Score
                    <i v-if="!overrideRiskProfile" class="ui icon check"></i
                    ><br />
                    <span style="font-size: small"
                      >time horizon, liquidity, capacity
                    </span></Section
                  ></a
                >
              </div>
              <div class="ui column" style="text-align: center">
                <a href="#" @click.prevent="overrideRiskProfile = true"
                  ><Section
                    :style="
                      overrideRiskProfile
                        ? 'background-color: rgba(80, 180, 80, 0.2); font-weight: bold; font-size: 1.3em; color: black;cursor: text'
                        : 'font-weight: bold; font-size: 1.3em'
                    "
                  >
                    Manual
                    <i v-if="overrideRiskProfile" class="ui icon check"></i
                    ><br />
                    <span style="font-size: small">subjective judgment </span>
                  </Section></a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!overrideRiskProfile" class="ui row">
        <br />

        <div class="ui column">
          <div class="ui attached message">
            <h4>Risk Ability Scoring Sheet</h4>
          </div>
          <div class="ui attached segment">
            <span v-if="false">
              <br />
              Goal time horizon: "the period between when a goal is established
              and the date of that goal’s achievement, which in some cases may
              exceed the investor’s remaining lifetime." <br />
              <br />
              Liquidity needs: "Need for liquidity is defined as an objective
              requirement or desire to hold cash for ongoing current or future
              expected distribution needs" <br />
              Risk capacity: "refers to an investor’s financial capability to
              withstand a financial loss without meaningfully compromising her
              desired standard of living"
            </span>
            <sui-form>
              <Section style="background-color: rgba(150, 173, 216, 0.2)"
                ><strong for="goalTimeHorizon"
                  >1. Goal Time Horizon</strong
                ></Section
              >
              <Section
                style="
                  background-color: rgba(242, 242, 242, 0.7);
                  margin-bottom: 0;
                "
              >
                <div class="ui five column grid">
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="goalTimeHorizon"
                        name="goalTimeHorizon"
                        label="Less than 1 year"
                        :value="1"
                      />
                    </sui-form-field>
                  </div>
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="goalTimeHorizon"
                        name="goalTimeHorizon"
                        label="Between 1 and 3 years"
                        :value="2"
                      />
                    </sui-form-field>
                  </div>
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="goalTimeHorizon"
                        name="goalTimeHorizon"
                        label="Between 3 and 7 years"
                        :value="3"
                      />
                    </sui-form-field>
                  </div>

                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="goalTimeHorizon"
                        name="goalTimeHorizon"
                        label="Between 7  and 10 years"
                        :value="4"
                      />
                    </sui-form-field>
                  </div>

                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="goalTimeHorizon"
                        name="goalTimeHorizon"
                        label="More than 10 years"
                        :value="5"
                      />
                    </sui-form-field>
                  </div>
                </div>
              </Section>
              <div class="ui divider"></div>
              <Section style="background-color: rgba(150, 173, 216, 0.2)"
                ><strong for="liquidityNeeds"
                  >2. Ongoing annual Liquidity Needs
                </strong>
              </Section>
              <Section style="background-color: rgba(242, 242, 242, 0.7)">
                <div class="ui three column grid">
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="liquidityNeeds"
                        name="liquidityNeeds"
                        label="Very High (more than +- 5%)"
                        :value="1"
                      />
                    </sui-form-field>
                  </div>

                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="liquidityNeeds"
                        name="liquidityNeeds"
                        label="Moderate (less than 5% of portfolio value)"
                        :value="3"
                      />
                    </sui-form-field>
                  </div>

                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="liquidityNeeds"
                        name="liquidityNeeds"
                        label="No immediate ongoing liquidity needs"
                        :value="5"
                      />
                    </sui-form-field>
                  </div></div
              ></Section>
              <div class="ui divider"></div>
              <Section style="background-color: rgba(150, 173, 216, 0.2)"
                ><strong for="knowledgeable">3. Risk Capacity</strong></Section
              >
              <Section style="background-color: rgba(242, 242, 242, 0.7)">
                <div class="ui three column grid">
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="riskCapacity"
                        name="riskCapacity"
                        label="No outside income or assets available"
                        :value="1"
                      />
                    </sui-form-field>
                  </div>

                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="riskCapacity"
                        name="riskCapacity"
                        label="Moderate amount of outside income or assets available"
                        :value="3"
                      />
                    </sui-form-field>
                  </div>

                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="riskCapacity"
                        name="riskCapacity"
                        label="Sufficient outside income or asset are available "
                        :value="5"
                      />
                    </sui-form-field>
                  </div></div
              ></Section>
            </sui-form>
          </div>

          <div class="ui segment">
            <div class="ui equal width grid">
              <div class="ui equal width row" v-if="riskProfiles">
                <div
                  v-for="rp in riskProfiles"
                  class="ui column"
                  style="text-align: center"
                >
                  <Section
                    :style="
                      rp.id ==
                      goalRiskProfile.getRiskAbilityResponse.riskProfileId
                        ? 'background-color: rgba(80, 180, 80, 0.2); font-weight: bold'
                        : ''
                    "
                    >{{ rp.riskProfileName }}</Section
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="overrideRiskProfile" class="ui row">
        <br />
        <div class="ui column">
          <div class="ui attached message">
            <h4>Subjective Assessment of Risk-Taking Ability</h4>
          </div>

          <div class="ui attached segment">
            <v-select
              label="riskProfileName"
              @input="handleRiskChanged"
              :reduce="(op) => op.id"
              v-model="overrideRiskProfileId"
              :options="riskProfiles"
            >
              <template v-slot:option="option">{{
                option.riskProfileName
              }}</template>
            </v-select>
            <br />
            <div class="ui form">
              <div class="field">
                <label>(optional) Notes</label>
                <textarea v-model="overrideMessage" rows="5"></textarea>
              </div>
              <small>
                "Although some subjectivity is involved, consideration of an
                investor’s goal time horizon, liquidity needs, and capacity to
                take risk all inform a financial advisor’s professional judgment
                about the investor’s risk-taking ability", Source: CFA</small
              >
            </div>
          </div>
          <div class="ui segment">
            <div class="ui equal width grid"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from "lodash";
import numeral from "numeral";
import vSelect from "vue-select";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import "vue-select/dist/vue-select.css";
import { getRiskProfiles, getRiskAbility } from "@/gateway.js";
import {
  GetIncomeCashFlowRequest,
  GetContributionCashFlowRequest,
} from "@/dtos";
export default {
  name: "GoalTypes",
  components: { vSelect, VueSlider },
  props: [
    "currency",
    "goalRiskProfile",
    "getRiskAbilityResponse",
    "activePlan",
  ],
  data() {
    return {
      initial: false,
      riskCapacity: 0,
      liquidityNeeds: 0,
      goalTimeHorizon: 0,

      overrideRiskProfileId: null,
      riskProfileId: null,
      riskProfiles: [],
      overrideMessage:
        "The risk-taking ability has been subjectively evaluated based on the discussions with the client",
      overrideRiskProfile: false,
      // getRiskAbilityResponse: null
    };
  },
  computed: {
    minScore() {
      console.log(
        "minscore",
        Math.min(this.riskCapacity, this.liquidityNeeds, this.goalTimeHorizon)
      );
      return Math.min(
        this.riskCapacity,
        this.liquidityNeeds,
        this.goalTimeHorizon
      );
    },
  },
  watch: {
    minScore(newValue) {
      this.handleRiskChanged();
    },
    overrideMessage(newValue) {
      this.handleNoteChanged();
    },
    overrideRiskProfile(newValue) {
      this.handleRiskChanged();
    },
  },
  methods: {
    async calculateRiskAbility() {
      let getIncomeCashFlowRequestR = new GetIncomeCashFlowRequest({
        income: this.activePlan.getIncomeCashFlowRequest.income,
        incomeGrowth: this.activePlan.getIncomeCashFlowRequest.incomeGrowth,
        incomeGrowthFrequency: this.activePlan.getIncomeCashFlowRequest
          .incomeGrowthFrequency,
        payoutFrequency: this.activePlan.getIncomeCashFlowRequest
          .payoutFrequency,
        incomeToLast: this.activePlan.getIncomeCashFlowRequest.incomeToLast,
        startYear: this.activePlan.getIncomeCashFlowRequest.startYear,
        currentAge: this.activePlan.getIncomeCashFlowRequest.currentAge,

        taxRate: this.activePlan.getIncomeCashFlowRequest.taxRate,
        hasAdhocCashFlow: this.activePlan.getIncomeCashFlowRequest
          .hasAdhocCashFlow,
        adhocCashFlowAge1: this.activePlan.getIncomeCashFlowRequest
          .adhocCashFlowAge1,
        adhocCashFlowAge2: this.activePlan.getIncomeCashFlowRequest
          .adhocCashFlowAge2,
        adhocCashFlowAge3: this.activePlan.getIncomeCashFlowRequest
          .adhocCashFlowAge3,
        adhocCashFlow1: this.activePlan.getIncomeCashFlowRequest.adhocCashFlow1,
        adhocCashFlow2: this.activePlan.getIncomeCashFlowRequest.adhocCashFlow2,
        adhocCashFlow3: this.activePlan.getIncomeCashFlowRequest.adhocCashFlow3,
      });

      let getContributionCashFlowRequestR = new GetContributionCashFlowRequest({
        applyContribution: this.activePlan.getContributionCashFlowRequest
          .applyContribution,
        contribution: this.activePlan.getContributionCashFlowRequest
          .contribution,
        contributionFrequency: this.activePlan.getContributionCashFlowRequest
          .contributionFrequency,
        contributionGrowth:
          this.activePlan.getContributionCashFlowRequest.contributionGrowth /
          100,
        contributionGrowthFrequency: this.activePlan
          .getContributionCashFlowRequest.contributionGrowthFrequency,
        contributionToLast: this.activePlan.getContributionCashFlowRequest
          .contributionToLast,
        contributionStartYear: this.activePlan.getContributionCashFlowRequest
          .contributionStartYear,
      });

      const response = await getRiskAbility({
        currency: this.currency,
        goal: this.activePlan.goalInfo,
        lumpSum: this.activePlan.accounts[0].accountMarketValue,
        getIncomeCashFlowRequest: getIncomeCashFlowRequestR,
        getContributionCashFlowRequest: getContributionCashFlowRequestR,
        overrideMessage: this.overrideMessage,
        overrideRiskProfileId: this.overrideRiskProfileId,

        override: this.overrideRiskProfile,

        liquidityNeeds: this.liquidityNeeds,
        riskCapacity: this.riskCapacity,
        goalTimeHorizon: this.goalTimeHorizon,
      });
      if (response) {
        this.getRiskAbilityResponse = response;
        this.goalRiskProfile.getRiskAbilityResponse = response;

        this.overrideRiskProfileId = this.goalRiskProfile.getRiskAbilityResponse.overrideRiskProfileId;
        this.overrideRiskProfile = this.goalRiskProfile.getRiskAbilityResponse.override;
        this.overrideMessage = this.goalRiskProfile.getRiskAbilityResponse.overrideMessage;

        this.liquidityNeeds = this.goalRiskProfile.getRiskAbilityResponse.liquidityNeeds;
        this.riskCapacity = this.goalRiskProfile.getRiskAbilityResponse.riskCapacity;
        this.goalTimeHorizon = this.goalRiskProfile.getRiskAbilityResponse.goalTimeHorizon;

        this.riskProfileId = this.goalRiskProfile.riskProfileId;
      }
    },
    async handleNoteChanged() {
      this.goalRiskProfile.getRiskAbilityResponse.overrideMessage = this.overrideMessage;
    },
    async handleRiskChanged() {
      await this.calculateRiskAbility();
    },
    async initialSelection(override) {
      var response = await getRiskProfiles({ currency: this.currency });
      if (response) {
        this.riskProfiles = response.result;
        this.overrideRiskProfile = override;
        //this.overrideRiskProfileId = this.riskProfiles[0].id;
        this.init();
      }
    },
    async init() {
      var response = await getRiskProfiles({ currency: this.currency });
      if (response) {
        this.riskProfiles = response.result;

        if (this.goalRiskProfile.getRiskAbilityResponse) {
          this.overrideRiskProfileId = this.goalRiskProfile.getRiskAbilityResponse.overrideRiskProfileId;
          this.overrideRiskProfile = this.goalRiskProfile.getRiskAbilityResponse.override;
          this.overrideMessage = this.goalRiskProfile.getRiskAbilityResponse.overrideMessage;

          this.liquidityNeeds = this.goalRiskProfile.getRiskAbilityResponse.liquidityNeeds;
          this.riskCapacity = this.goalRiskProfile.getRiskAbilityResponse.riskCapacity;
          this.goalTimeHorizon = this.goalRiskProfile.getRiskAbilityResponse.goalTimeHorizon;

          this.riskProfileId = this.goalRiskProfile.riskProfileId;
        } else {
          await this.calculateRiskAbility();
        }
      }
    },
  },
  mounted() {
    if (this.getRiskAbilityResponse) this.init();
  },
};
</script>
<style scoped>
.selecthover tr {
  cursor: pointer;
}
</style>
